import { useFinishedResults } from "@/features/_shared/hooks/useFinishedResults";
import RotatingScreens from "@/features/_shared/components/RotatingScreens";
import { dataProps } from "@/models/data.model";
import { FC, JSX } from "react";

import EndscreenView from "../endscreen/EndscreenView";
import ChallengeUpcoming from "./challengeUpcoming";

// Shown while a challenge is upcoming. If a previous challenge has results, we
// rotate between those results and the "next challenge" countdown so the board
// keeps showing winners during the whole gap until the next challenge starts.
const GapScreen: FC<dataProps> = (data): JSX.Element => {
  const { challenge, leaderboard, hasResults, loading } = useFinishedResults();

  if (loading || !hasResults) {
    return <ChallengeUpcoming {...data} />;
  }

  return (
    <RotatingScreens
      intervalMs={15000} // TEMP TEST: 4s for quick preview; set back to 15000
      screens={[
        <EndscreenView
          key="results"
          leaderboard={leaderboard}
          challenge={challenge}
        />,
        <ChallengeUpcoming key="countdown" {...data} />,
      ]}
    />
  );
};

export default GapScreen;
